import { TabularCopySource } from 'app/model/pipeline/copysource/tabular-type.copysource';
import { IAttribute, Metamodel, SapODataDataset } from 'shell-models-lib';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.sapOData.copySourceType,
    display: [],
    tags: {
        datasetModel: [
            Metamodel.modelFor(SapODataDataset)
        ]
    }
})
export class SapODataCopySource extends TabularCopySource {
    public static readonly EXTRACTION_MODE: IAttribute;
    public static readonly DELTA_TOKEN: IAttribute;
    public static readonly PROJECTION: IAttribute;
    public static readonly SELECTION: IAttribute;
    public static readonly BATCH_SIZE: IAttribute;
    public static readonly HTTP_REQUEST_TIMEOUT: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'EXTRACTION_MODE',
        display: stringResources.Extraction_Mode
    })
    public extractionMode?: 'Full' | 'Delta' | 'Recovery' = 'Full';

    @Metamodel.attribute({
        templatable: true,
        association: 'DELTA_TOKEN',
        display: stringResources.DeltaToken
    })
    public deltaToken: string;

    @Metamodel.attribute({
        display: stringResources.DataFlowProjectionPanel_Projection,
        templatable: true,
        association: 'PROJECTION',
        accepts: ['Array']
    })
    public projection: string[] = [];

    @Metamodel.attribute({
        display: stringResources.Selection,
        templatable: true,
        association: 'SELECTION',
        accepts: ['Array']
    })
    public selection: string[] = [];

    @Metamodel.attribute({
        display: stringResources.ModelName_BatchSize,
        templatable: true,
        association: 'BATCH_SIZE'
    })
    public batchSize: number;

    @Metamodel.attribute({
        display: stringResources.Timeout,
        templatable: true,
        association: 'HTTP_REQUEST_TIMEOUT'
    })
    public httpRequestTimeout: number;
}
